import script from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=1f0b717a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f0b717a"]])

export default __exports__